var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-col"},[(_vm.loading)?_c('half-circle-spinner',{staticClass:"mx-auto",attrs:{"animation-duration":1500,"size":20,"color":"#008ecf"}}):_c('div',{staticClass:"cursor-pointer",on:{"click":_vm.onUrlClick}},[_c('i',{staticClass:"fa fa-money text-primary"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }